/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ModelClassifier extends models.AggregateMetricsBase {
    getFixupPrototypeFunction() { return ModelClassifier.fixupPrototype; }

    static newInstance(model: Partial<ModelClassifier>): ModelClassifier {
        let obj = Object.assign(new ModelClassifier(), model);
        ModelClassifier.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ModelClassifier>): ModelClassifier {
        if (!model) return null;
        return ModelClassifier.newInstance(<ModelClassifier> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ModelClassifier) {
        if (!obj) return;

        models.ModelClassifier.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ModelClassifier): boolean {
        if (models.AggregateMetricsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ModelClassifier.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Model ID
     */
    model_id: string;

    /**
     * LLM Provider
     */
    provider: string;

    /**
     * Quantity Of measure
     */
    quantity_of_measure: models.AIQuanityOfMeasure;

}
